import { create } from 'zustand'
import type { Answer } from '../lib/api'

/** Where the visitor landed on the waitlist. Null position = placed, number unknown. */
export type Placement = { position: number | null; alreadyOnList: boolean }

type FunnelUiState = {
  answers: Record<string, Answer>
  direction: 'forward' | 'back'
  researchConsent: boolean | null
  placement: Placement | null
  setAnswer: (key: string, answer: Answer) => void
  hydrate: (answers: Record<string, Answer>) => void
  setDirection: (direction: 'forward' | 'back') => void
  setResearchConsent: (value: boolean | null) => void
  setPlacement: (placement: Placement) => void
}

/**
 * In-memory only, deliberately: answers live on the server (the funnel session
 * is the source of truth and rehydrates on load), and keeping them out of
 * localStorage is asserted by both the unit and e2e tests.
 */
export const useFunnelStore = create<FunnelUiState>((set) => ({
  answers: {},
  direction: 'forward',
  researchConsent: null,
  placement: null,
  setAnswer: (key, answer) => set((state) => ({ answers: { ...state.answers, [key]: answer } })),
  hydrate: (answers) => set({ answers }),
  setDirection: (direction) => set({ direction }),
  setResearchConsent: (researchConsent) => set({ researchConsent }),
  setPlacement: (placement) => set({ placement }),
}))
